import React from 'react'
import MainBanner from '../MainBanner'
import FloatBanner from '../FloatBanner'
import GreenBackGround from '../GreenBackGround'
import { GREEN_DATA, VIEW_MODE } from '../../constant'
import EcommerceIntro from '../EcommerceIntro'
import FinanceIntro from '../FinanceIntro'
import Promotion from '../Promotion'
import PropTypes from 'prop-types'
import CashFlow from '../CashFlow'
import StationKnowledgeUgly from '../StationKnowledgeUgly'

const HomePageContent = props => {
  const { mode, data } = props

  return (
    <>
      <MainBanner data={data} />
      <FloatBanner data={data} />
      {data?.businessStationConfig && (
        <GreenBackGround mode={mode} greenData={data?.businessStationConfig} id={GREEN_DATA.CASH_FLOW.ID} />
      )}
      {data?.businessStationConfig && <CashFlow mode={mode} cashData={data?.businessStationConfig} />}
      {data?.ecommerceStationConfig && (
        <GreenBackGround mode={mode} greenData={data?.ecommerceStationConfig} id={GREEN_DATA.E_COMMERCE.ID} />
      )}
      {data?.ecommerceStationConfig && <EcommerceIntro mode={mode} ecommerceData={data?.ecommerceStationConfig} />}
      {data?.financialStationConfig && (
        <GreenBackGround mode={mode} greenData={data?.financialStationConfig} id={GREEN_DATA.FINANCE.ID} />
      )}
      {data?.financialStationConfig && <FinanceIntro mode={mode} financeData={data?.financialStationConfig} />}
      {data?.knowledgeStationConfig && (
        <GreenBackGround mode={mode} greenData={data?.knowledgeStationConfig} id={GREEN_DATA.KNOWLEDGE.ID} />
      )}
      {data?.knowledgeStationConfig && <StationKnowledgeUgly mode={mode} knowledgeData={data?.knowledgeStationConfig} />}
      {data?.eventAndNewsConfig && <Promotion id={'PROMOTION'} promotionData={data?.eventAndNewsConfig} />}
    </>
  )
}

HomePageContent.propTypes = {
  mode: PropTypes.oneOf([VIEW_MODE.PUBLIC, VIEW_MODE.PREVIEW]).isRequired,
}

export default HomePageContent
